// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-gap[data-v-54baa585] {\n  margin-top: 10px;\n}\n.button-location-gap[data-v-54baa585] {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
